import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Spin, Form, Divider, Col } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import { chargeApi, chargeLabel, chargeStatic } from "./charge.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import ChargeSlab, { buildChargeSlabList } from "./view/ChargeSlab";
import ChargeSlabModal from "./view/ChargeSlabModal";

const { Text, Title } = Typography;

const DetailCharge = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [chargeDetail, setChargeDetail] = useState({});
  const [inputField, setInputField] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("generalInfo");
  const [isLoading, setIsLoading] = useState(false);
  const [chargeSlabList, setChargeSlabList] = useState([]);
  const [selectedSlabRows, setSelectedSlabRows] = useState([]);
  const [slabSelectionReset, setSlabSelectionReset] = useState(0);
  const [isSlabModalOpen, setIsSlabModalOpen] = useState(false);
  const [slabModalMode, setSlabModalMode] = useState("add");
  const [editingSlab, setEditingSlab] = useState(null);
  const [nextSlabKey, setNextSlabKey] = useState(1);

  const detailTabList = [
    { key: "generalInfo", label: "General Info" },
    chargeDetail?.chargeAppliesTo?.id === 2 && { key: "chargeSlab", label: "Charge Slab" },
  ];

  const configureGeneralInfoSidebar = () => {
    dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    if (!state.variant && BOM.HasPermission("DELETE_CHARGE")) {
      dispatch({ type: cnt.RIGHT_DELETE_BTN });
    }
  };

  const configureSlabSidebar = (selectedCount = 0) => {
    dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    dispatch({ type: cnt.RIGHT_ADD_BTN });

    if (selectedCount === 1) {
      dispatch({ type: cnt.RIGHT_EDIT_BTN });
      dispatch({ type: cnt.RIGHT_DELETE_BTN });
    }
  };

  const handleSlabSelectionChange = (selectedRows) => {
    setSelectedSlabRows(selectedRows);
    configureSlabSidebar(selectedRows.length);
  };

  const handleTabChange = (key) => {
    setActiveTabKey(key);

    if (key === "chargeSlab") {
      setSelectedSlabRows([]);
      setSlabSelectionReset((current) => current + 1);
      configureSlabSidebar(0);
      return;
    }

    setSelectedSlabRows([]);
    configureGeneralInfoSidebar();
  };

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${chargeApi.Charges}/${state.id}?template=true`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setChargeDetail(objDetail);
        const initialSlabs = buildChargeSlabList(objDetail);
        setChargeSlabList(initialSlabs);
        setNextSlabKey(
          initialSlabs.reduce((maxKey, slab) => Math.max(maxKey, Number(slab.key) || 0), 0) + 1,
        );

        setInputField([
          {
            name: chargeLabel.chargeId,
            value: objDetail.id,
          },
          {
            name: chargeLabel.chargeName,
            value: objDetail.name,
          },
          {
            name: chargeLabel.amount,
            value: objDetail.amount,
          },
          {
            name: chargeLabel.currency,
            value: objDetail.currency.displayLabel,
          },
          {
            name: chargeLabel.chargeAppliesTo,
            value: objDetail.chargeAppliesTo.value,
          },
          {
            name: chargeLabel.isPenalty,
            value: objDetail.penalty,
          },
          {
            name: chargeLabel.chargeCalculationType,
            value: objDetail.chargeCalculationType.value,
          },
          {
            name: chargeLabel.chargePaymentMode,
            value: objDetail.chargePaymentMode.value,
          },
          {
            name: chargeLabel.chargeTimeType,
            value: objDetail.chargeTimeType.value,
          },
          {
            name: chargeLabel.freeWithdrawal,
            value: objDetail.freeWithdrawal,
          },
          {
            name: chargeLabel.isPaymentType,
            value: objDetail.isPaymentType,
          },
          {
            name: chargeLabel.restartFrequency,
            value: objDetail.restartFrequency,
          },
        ]);

        // ENABLE DELETE BUTTON
        if (!state.variant) {
          configureGeneralInfoSidebar();
        }

        setIsLoading(false);
      }
    });
  };

  const handleOnAdd = () => {
    if (activeTabKey !== "chargeSlab" || rightBtn.addBtn?.toLowerCase() !== "primary") {
      return;
    }

    setSlabModalMode("add");
    setEditingSlab(null);
    setIsSlabModalOpen(true);
  };

  const handleOnEdit = () => {
    if (
      activeTabKey !== "chargeSlab" ||
      rightBtn.editBtn?.toLowerCase() !== "primary" ||
      !selectedSlabRows[0]
    ) {
      return;
    }

    const selectedSlab = chargeSlabList.find((slab) => slab.key === selectedSlabRows[0].key);
    if (!selectedSlab) {
      return;
    }

    setSlabModalMode("edit");
    setEditingSlab(selectedSlab);
    setIsSlabModalOpen(true);
  };

  const handleSlabModalCancel = () => {
    setIsSlabModalOpen(false);
    setEditingSlab(null);
  };

  const handleSlabModalSubmit = (values) => {
    if (slabModalMode === "edit" && editingSlab) {
      setChargeSlabList((current) =>
        current.map((slab) =>
          slab.key === editingSlab.key
            ? {
                ...slab,
                ...values,
              }
            : slab,
        ),
      );
    } else {
      const newSlabKey = nextSlabKey;
      setChargeSlabList((current) => [
        ...current,
        {
          id: newSlabKey,
          key: newSlabKey,
          ...values,
        },
      ]);
      setNextSlabKey(newSlabKey + 1);
    }

    setIsSlabModalOpen(false);
    setEditingSlab(null);
    setSelectedSlabRows([]);
    setSlabSelectionReset((current) => current + 1);
    configureSlabSidebar(0);
  };

  const handleOnDeleteSlab = () => {
    if (rightBtn.deleteBtn?.toLowerCase() !== "primary" || !selectedSlabRows[0]) {
      return;
    }

    const selectedSlab = selectedSlabRows[0];

    Notiflix.Confirm.show(
      "Are you sure?",
      "Delete charge slab",
      "Yes",
      "No",
      function () {
        setChargeSlabList((current) => current.filter((slab) => slab.key !== selectedSlab.key));
        setSelectedSlabRows([]);
        setSlabSelectionReset((current) => current + 1);
        configureSlabSidebar(0);
      },
      function () {},
    );
  };

  const handleOnDelete = () => {
    if (activeTabKey === "chargeSlab") {
      handleOnDeleteSlab();
      return;
    }

    let action = "Delete  ";
    let label = chargeDetail.name;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${chargeApi.Charges}/${chargeDetail.id}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, chargeLabel.deleteChargeMsg);
              navigate("/prd1000");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/prd1000");
              setIsLoading(false);
            },
          },
        );
      },
      function () {
        // No button
      },
    );
  };
  return (
    <MainLayout
      isEnableRightSidebar={true}
      onAdd={handleOnAdd}
      onEdit={handleOnEdit}
      onDelete={handleOnDelete}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={chargeLabel.chargeDetail}
        pageItems={
          state.variant ? chargeStatic.viewChargeBreadCrumbItems : chargeStatic.detailChargeItems
        }
      />

      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginBottom: 50,
          }}
          tabList={detailTabList}
          activeTabKey={activeTabKey}
          onTabChange={handleTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          <Form form={useForm} layout="vertical" style={{ paddingTop: 20 }}>
            {activeTabKey === "generalInfo" && (
              <>
                <Row>
                  <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                    {chargeLabel.generalInfo}
                  </Title>
                </Row>
                <Divider style={{ marginTop: 10, marginBottom: 30 }} />
                <Row>
                  {inputField.map((item, index) => (
                    <Col span={8} style={{ padding: "0px 8px" }} key={index}>
                      <Form.Item label={<Text strong>{item.name}</Text>}>
                        <Input disabled value={item.value} className="of-bold-disable-input" />
                      </Form.Item>
                    </Col>
                  ))}
                </Row>
              </>
            )}
            {activeTabKey === "chargeSlab" && (
              <ChargeSlab
                chargeSlabs={chargeSlabList}
                onSelectionChange={handleSlabSelectionChange}
                resetSelection={slabSelectionReset}
              />
            )}
          </Form>
        </Card>

        <ChargeSlabModal
          open={isSlabModalOpen}
          mode={slabModalMode}
          initialValues={editingSlab}
          onCancel={handleSlabModalCancel}
          onSubmit={handleSlabModalSubmit}
        />

        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailCharge);
